/// 顶部 --- 统计数据
export const totalConfig = {
    "MN250冠益乳铺市率": "89%",
    "YL250畅轻铺市率": "88%",
    // "JLB囤货数":"1200",
    // "YL囤货数": "6862",
  }
  
  /// ----
  export const tableDataArr1 = {
    "product": ["07-01","07-02","07-03","07-04","07-05","07-06","07-07","07-08"],
      "MN250冠益乳铺市率": [551,381,452,262,527,443,374,618],
      // "YL囤货数": [485,307,365,387,361,385,496,392],
      // "JLB囤货数": [100,100,100,100,100,100,100,100],
      "YL250畅轻铺市率": [316,176,235,244,254,248,176,261]   
  }
  export const tableDataArr2 = 
    {
      "MN250冠益乳铺市率": [944,1742,1207,1800,1042,755,738,1247,490,929,1094,802],
      "product": ["北京","东北","华北","华东","华南","华中","闽赣","山东","上海","西北","西南","豫皖"],
      // "YL囤货数": [855,1358,1041,1497,753,580,643,1122,366,856,759,653],
      // "JLB囤货数": [100,100,100,100,100,100,100,100,100,100,100,100],
      "YL250畅轻铺市率": [401,839,619,1048,667,502,559,617,343,384,449,434]
    }
  
  export const tableDimensionArr = ["product", "MN250冠益乳铺市率", "YL250畅轻铺市率"]
  
  ///
  export const modernChartDataArr = [
    {
      "type": "line",
      "stack": "vistors",
      "barWidth": "70%",
      "label": {
        "normal": {
          "show": true,
          "color": "black",
          "fontSize": 10,
          "position": "inside"
        }
      },
      "animationDuration": 2800,
      "animationEasing": "cubicInOut"
    },
    {
      "type": "line",
      "stack": "vistors",
      "barWidth": "70%",
      "label": {
        "normal": {
          "show": true,
          "color": "black",
          "fontSize": 10,
          "position": "inside"
        }
      },
      "animationDuration": 2800,
      "animationEasing": "cubicInOut"
    },
    // {
    //   "type": "bar",
    //   "stack": "vistors",
    //   "barWidth": "70%",
    //   "label": {
    //     "normal": {
    //       "show": true,
    //       "color": "black",
    //       "fontSize": 10,
    //       "position": "inside"
    //     }
    //   },
    //   "animationDuration": 2800,
    //   "animationEasing": "cubicInOut"
    // },
    // {
    //   "type": "bar",
    //   "stack": "vistors",
    //   "barWidth": "70%",
    //   "label": {
    //     "normal": {
    //       "show": true,
    //       "color": "black",
    //       "fontSize": 10,
    //       "position": "inside"
    //     }
    //   },
    //   "animationDuration": 2800,
    //   "animationEasing": "cubicInOut"
    // },
  ]
  
  
  


// WEBPACK FOOTER //
// ./src/components/kpi/config/AllStock.js